import { LiveClass } from '../../AoVivo/models/LiveClassDto.model';
import { Tour } from '../models/Tour.model';

/**
 * Normaliza um evento de onboarding (`Tour`) para o shape de `LiveClass`, para
 * que ele possa ser exibido junto das aulas ao vivo no cronograma AprovaLive
 * sem quebrar os componentes que assumem campos de `LiveClass` (ex.: `area`).
 *
 * O `type` é preservado como `'onboarding'` para que o clique roteie para o
 * fluxo de join (marca presença) em vez do register de aula ao vivo.
 */
export function mapTourToLiveEvent(tour: Tour): LiveClass {
  return {
    _id: tour._id,
    id: tour.id,
    display: tour.display,
    title: tour.title,
    slug: tour.slug,
    description: tour.description,
    startDate: tour.startDate,
    endDate: tour.endDate,
    thumbnail: tour.thumbnail,
    styles: tour.styles,
    type: 'onboarding',
    isSubscribed: tour.isSubscribed,
    isSubscriptionAllowed: tour.isSubscriptionAllowed,
    createdAt: tour.createdAt,
    updatedAt: tour.updatedAt,
    teacher: '',
    webinarAccount: '',
    area: { _id: '', title: 'Onboarding', slug: 'onboarding' },
    zoomToken: tour.zoomToken,
  };
}
